import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-09/task-01";

const task: Slide = {
  titleHtml:
    "Consider a loudspeaker membrane moving sinusoidally at the input of an infinite tube,<br>the amplitude of the oscillation is 1 mm and frequency is 200 Hz. The cross<br>section of the tube being 5 cm<sup>2</sup>, calculate the velocity amplitude of the piston,<br>the acoustic pressure, and the power of the acoustic wave?",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
